import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import HomePage from './pages/Homepage';
import AdaptiveTabSVG from './pages/folder';
import RotatingBorderCircles from './components/AnimatedBlurBg';
import ParticleGrid from './components/AnimatedGridBg';
import ScrollNudger from './components/LookFurther';
import Navbar from './components/Navbar';
import NicknameManager from './pages/Projects/FunnyName';
import Projects from './pages/Projects/Projects';
import BusinessCard from './pages/BusinessCard';
import RegistrationGrid from './pages/test-crosses';
import FlowApp from './pages/node_page';
import LayoutComponent from './pages/node_page2';
import FlowApp2 from './pages/node_page3';
import Menu from './pages/lisa_menu_desktop';
import MobileMenu from './pages/lisa_menu_mobile';
import DesktopGrid from './pages/lisa_grid_desktop';
import MobileGrid from './pages/lisa_grid_mobile';
import CartPage from './pages/lisa_cart';
import ProductPage from './pages/lisa_product_desktop';
import DocumentViewer from './pages/markdown_viewer';
import BulkImageConverter from './pages/image-converter';
import { Chat } from '@mui/icons-material';
import ChatInterface from './pages/chat';
import WorkflowVisualizer from './pages/chat_nodes';
import ContractFormApp from './pages/contract';
import RAGChatClient from './pages/chat_websocket';
import CalendarMain from './pages/calendar_main';
import MeetingsRecordApp from './pages/calendar_meeting';
import AuthApp from './pages/Auth';
import AboutName from './pages/About';
import AboutPassions from './pages/About2';
import SphericalViewer from './pages/Spherical';

// placeholder components About pages
const AboutPage = () => (
  <div className="pt-20">
    <h1>About</h1>
    <p>Information about you or your organization.</p>
  </div>
);

// Route definitions with metadata
const routes = [
  { path: '/', element: <HomePage /> },
  { path: '/spherical', element: <SphericalViewer />, noNavbar: true },
];

// Wrapper component to use Router hooks
const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [projectsLabel, setProjectsLabel] = useState('projects');

  // Check current route config
  const currentRoute = routes.find(r => r.path === location.pathname);
  const showNavbar = !currentRoute?.noNavbar;

  useEffect(() => {
    // Only set up observer on home page
    if (location.pathname !== '/') {
      setProjectsLabel('projects');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setProjectsLabel('other projects');
          } else {
            setProjectsLabel('projects');
          }
        });
      },
      {
        threshold: 0.5,
        rootMargin: '0px'
      }
    );

    const heading = document.getElementById('latest-projects-heading');
    if (heading) {
      observer.observe(heading);
    }

    return () => {
      if (heading) {
        observer.unobserve(heading);
      }
    };
  }, [location.pathname]);

  return (
    <div className="App relative">
      {showNavbar && (
        <Navbar
          currentPath={location.pathname}
          onNavigate={(path) => navigate(path)}
          projectsLabel={projectsLabel}
        />
      )}
      <main>
        <Routes>
          {routes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;